import styled from "styled-components";

export const Container = styled.div`
  display: flex;
`;

export const Title = styled.span`
  width: 100%;
  text-align: left;
  margin: 2px 0px;
  font-weight: bold;

  @media (max-width: 768px) {
    margin: 1px 0px;
    font-size: 12px;
  }

  @media (max-width: 420px) {
    font-size: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 2px 0px;
  }
`;

export const Table = styled.div`
  display: flex;
  flex: 1;
  &:not(:nth-of-type(-n + 2)) {
    margin-left: 20px;
  }

  @media (max-width: 768px) {
    &:not(:nth-of-type(-n + 2)) {
      margin-left: 5px;
    }
  }

  @media (max-width: 420px) {
    display: inherit;
    flex: inherit;
  }
`;

export const RoofTitle = styled.span`
  font-weight: bold;
  color: ${(props) => props.color};
  @media (max-width: 768px) {
    transform: rotate(-45deg);
    padding: 0px 20px 0px 15px;
  }
`;

export const USPContainer = styled.div`
  display: flex;
  padding: 10px;
  font-size: 14px;

  .glyphicon {
    color: ${(props) => props.color};
    margin: 0px 5px;

    @media (max-width: 420px) {
      margin: 0px 2px;
    }
  }

  @media (max-width: 420px) {
    font-size: 10px;
    padding: 5px 2px;
  }
`;

export const SubTitle = styled.span`
  width: 100%;
  font-weight: normal;
  font-size: 12px;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 10px;
  }

  @media (max-width: 420px) {
    font-size: 9px;
    line-height: 0.9;
  }
`;

export const Header = styled.h2`
  text-align: center;
  margin: 20px 0px;

  @media (max-width: 768px) {
    text-align: left;
    font-size: 16px;
    margin: 50px 0px 0px 0px;
  }
`;

export const DataContainer = styled.div`
  height: 60px;
  text-align: center;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;

  &:not(:first-of-type):not(:last-of-type) {
    border-bottom: 1px solid grey;
  }

  &:first-of-type {
    justify-content: flex-start;
  }

  @media (max-width: 1200px) {
    svg {
      height: 40px;
      width: 40px;
    }
  }

  @media (max-width: 768px) {
    border-right: 1px solid grey;

    svg {
      height: 30px;
      width: 30px;
    }

    &:first-of-type {
      border-right: none;
    }

    padding: 2px 4px;
    &:first-of-type {
      padding-bottom: 2px;
      background: white;
      white-space: nowrap;
      overflow: visible;
      align-items: initial;
      justify-content: flex-end;
    }
  }
`;

export const Column = styled.div`
  flex: 1;
  border-bottom: 3px solid ${(props) => props.color};

  &:nth-of-type(odd) {
    background: ${({ theme }) => theme.light};
  }

  &:last-of-type {
    background: white;
  }

  &:nth-of-type(1) {
    border-left: 3px solid ${(props) => props.color};
  }

  &:not(:nth-of-type(-n + 1)) {
    border-left: 1px solid grey;
  }

  &:last-of-type {
    border-right: 3px solid ${(props) => props.color};
  }

  @media (max-width: 1200px) {
    width: 65px;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    width: 55px;
    font-size: 10px;

    &:nth-of-type(odd) {
      background: white;
    }

    &:not(:nth-of-type(-n + 1)) {
      border-left: none;
    }

    &:last-of-type {
      border-right: none;
      ${DataContainer}:not(:first-of-type) {
        border-right: 3px solid ${(props) => props.color};
      }
    }

    &:nth-of-type(1) {
      border-left: none;
      ${DataContainer}:not(:first-of-type) {
        border-left: 3px solid ${(props) => props.color};
      }
    }
  }

  @media (max-width: 420px) {
    width: 44px;
    font-size: 10px;
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 50px 0px;
`;

export const Card = styled.div`
  flex-basis: 22%;
  margin: 0px 30px;
  border-radius: 5px;
  padding: 10px 0px;
  border: 2px solid ${(props) => props.color};

  @media (max-width: 1200px) {
    flex: 1;
    margin: 0px 15px;
  }

  @media (max-width: 768px) {
    flex: 1;
    margin: 0px 10px;
  }

  @media (max-width: 420px) {
    flex: 1;
    margin: 0px 5px;
  }
`;

export const RoofThumbnail = styled.img`
  width: 50%;
  display: block;
  margin: 10px auto;
`;

export const CardTitle = styled.h3`
  background: ${(props) => props.color};
  color: white;
  font-size: 18px;
  padding: 10px 5px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  width: 80%;

  @media (max-width: 420px) {
    width: 95%;
    font-size: 11px;
    padding: 5px 5px;
  }

  @media (max-width: 376px) {
    font-size: 10px;
  }
`;

export const HeaderColumn = styled.div`
  flex: 2;

  @media (max-width: 420px) {
    ${DataContainer} {
      border-right: none;
    }
    flex: 0.85;
  }
`;
